export const API_URL = process.env.NEXT_PUBLIC_API_URL || 'https://essential-canvas-334d9b6ed5.strapiapp.com';
export const NEXT_PUBLIC_API_TOKEN = process.env.NEXT_PUBLIC_API_TOKEN
export const HOME_PAGE_SLUG = process.env.HOME_PAGE_SLUG || 'home';

export const RESULTS_PER_PAGE = 10;
export const ALL_CATEGORIES = 'All';
export const BLOG_DATE_FORMAT = 'MMM DD, YYYY';